<template>
    <div class="w-full overflow-x-hidden">
        <div class="container w-full">
            <div data-te-lightbox-init
                 data-te-container="#tw_app" ref="holder" class="flex flex-nowrap items-stretch inner align-stretch"
                :style="carouselSideScrollerStyles">
                <slot></slot>
            </div>
        </div>
    </div>

    <div class="container mt-4">
        <div class="sizer flex justify-between items-center content-center">

        <button :disabled='currentItem === 0'
                class='mx-1 flex items-center rotate-180 justify-center p-0 text-center carousel-side-scroller-button'
                :class="[(start) ? 'btn-inactive':'btn-dark']"
                @click='navigatePrev'><img :src="arrowIcon" style="width: 2.225rem" alt="previous"></button>
            <span class="hidden sm:block" :class="pulseClass">
                    <!-- <span v-for="(item, index) in items" v-on:click="navigateExact(index)" class="inline-block w-3 h-3 rounded-full mx-1 cursor-pointer" :class="[(index === currentItem) ? 'bg-light-olive-green' : 'bg-light-grey-green']">&nbsp;</span>-->
                    <span class="inline-block transition-[color] h-4 rounded-full mx-1 "
                          :class="[(start)?'w-16 bg-light-olive-green':'w-4 bg-light-grey-green']">&nbsp;</span>
                    <span class="inline-block transition-[color] h-4 rounded-full mx-1 "
                          :class="[(middle)?'w-16 bg-light-olive-green':'w-4 bg-light-grey-green']">&nbsp;</span>
                    <span class="inline-block transition-[color] h-4 rounded-full mx-1 "
                          :class="[(end)?'w-16 bg-light-olive-green':'w-4 bg-light-grey-green']">&nbsp;</span>
            </span>
        <button :disabled='currentItem === (items.length - itemsFitWidth)'
                class='mx-1 btn-dark flex  items-center justify-center p-0 carousel-side-scroller-button'
                :class="[(end) ? 'btn-inactive':'btn-dark']"
                @click='navigateNext'><img :src="arrowIcon" style="width: 2.225rem" alt="next" class=""></button>
        </div>
    </div>
</template>

<script>
import {onMounted} from "vue";
import {
    Lightbox,
    initTE,
} from "tw-elements";



export default {
    name: "GalleryCarousel",
    props: {
        cardWidth: {
            type: Number,
            default: 300
        },
        numberOfItems: {
            type: Number,
            default: 0
        },
        arrowIcon: {
            type: String,
            default: ''
        },
        gap: {
            type: Number,
            default: 8
        }
    },
    data: {
        items: [],
        widths: [],
        trueCardWidth: 0,
        pageWidth: 0,
        carouselWidth: 0,
        currentItem: 0,
        scrollBlockWidth: 0,
        cardGap: 8,
        reportedCardWidth: 0,
        scrollOffset: 0,
        scrollAreaWidth: 0,
        changing: false
    },
    computed: {
        sumWidths: function () {
            return this.widths.reduce((a, b) => parseInt(a) + parseInt(b) + this.cardGap, 0);
        },
        scrollAllowedMax: function () {
            return this.sumWidths - this.scrollAreaWidth;
        },
        offset: function () {
            if (this.scrollOffset > this.scrollAllowedMax) {
                return this.scrollAllowedMax;
            }
            if (this.scrollOffset < 0) {
                return 0;
            }
            return this.scrollOffset;
        },
        carouselSideScrollerStyles: function () {
            return 'margin-left: -' + this.offset + 'px; gap: ' + this.cardGap + 'px;';
        },
        itemsFitWidth: function () {
            return Math.floor(this.carouselWidth / this.scrollBlockWidth);
        },
        pulseClass: function () {
            if (!this.changing) {
                return '';
            }
            if (this.changing === 'left') {
                return 'pulse-left';
            }
            if (this.changing === 'right') {
                return 'pulse-right';
            }

        },
        start: function () {
            return (this.offset === 0);
        },
        end: function () {
            return (this.offset === this.scrollAllowedMax);
        },
        middle: function () {
            return (!this.start && !this.end);
        }
    },
    watch: {
        changing: function () {
            if (this.changing) {
                setTimeout(() => {
                    this.changing = false;
                }, 200);
            }
        }
    },
    components: {},
    created: function () {
        // this.items = this.$slots.default();

    },
    beforeDestroy: function () {
        Array.from(this.items).forEach(item => {
            if (item.nodeName === 'PICTURE') {
                let imgElement = item.getElementsByTagName('img')[0];
                if (imgElement) {
                    imgElement.removeEventListener('load', this.setWidths);
                }
            }
        });
    },
    destroyed: function () {
        window.removeEventListener("resize", this.setWidths);
    },
    mounted: function () {
        this.items = this.$refs.holder.children;
        this.setWidths();
        this.reportedCardWidth = parseInt(this.cardWidth);
        window.addEventListener("resize", this.setWidths);
        this.cardGap = parseInt(this.gap);
        initTE({Lightbox});
        Array.from(this.items).forEach(item => {
            if (item.nodeName === 'PICTURE') {
                let imgElement = item.getElementsByTagName('img')[0];
                if (imgElement) {
                    imgElement.addEventListener('load', this.setWidths);
                }
            }
        });
    },
    methods: {
        setWidths: function () {
            this.scrollOffset = 0;
            let sizerElement = document.getElementsByClassName('sizer')[0];
            if (sizerElement) {
                this.scrollAreaWidth = sizerElement.offsetWidth;
            }
            this.trueCardWidth = (this.items[0].clientWidth > 0) ? this.items[0].clientWidth : parseInt(this.cardWidth);
            this.pageWidth = window.innerWidth;
            this.scrollBlockWidth = parseInt(this.trueCardWidth) + parseInt(this.cardGap);
            for (let i = 0; i < this.items.length; i++) {
                this.widths[i] = this.items[i].clientWidth;
            }
        },
        navigateExact: function (index) {
            let scrollWidth = 0;
            for (let i = 0; i < index; i++) {
                scrollWidth += parseInt(this.widths[i]) + this.cardGap;
            }
            this.scrollOffset = scrollWidth;
            this.currentItem = index;
            this.offsetSideScroller();
        },
        navigateNext: function () {
            this.changing = 'right';
            if (!this.end) {
                let currentItemWidth = parseInt(this.widths[this.currentItem]) + this.cardGap;
                this.scrollOffset += currentItemWidth;

                ++this.currentItem;
                this.offsetSideScroller();
            }
        },
        navigatePrev: function () {
            this.changing = 'left';
            if (!this.start) {
                let currentItemWidth = parseInt(this.widths[this.currentItem-1]) + this.cardGap;
                this.scrollOffset -= currentItemWidth;

                --this.currentItem;
                this.offsetSideScroller();
            }
        },
        offsetSideScroller: function () {

        }
    },
    render: h => h(App),
}
</script>

<style scoped>
::-webkit-scrollbar {
    width: 0;
    background: transparent; /* make scrollbar transparent */
}

.inner {
    transition: margin-left 0.2s ease-in-out;
}

/*noinspection ALL*/
.pulse-left span.bg-light-olive-green {
    animation: pulse-left 0.2s;
}
/*noinspection ALL*/
.pulse-right span.bg-light-olive-green {
    animation: pulse-right 0.2s;
}
@keyframes pulse-left {
    0% {
        background: linear-gradient(90deg, #e3dfd0 0%, #96ca51 100%);
    }
    100% {
        background: #96ca51;
    }
}
@keyframes pulse-right {
    0% {
        background: linear-gradient(90deg, #96ca51 0%, #e3dfd0 100%);
    }
    100% {
        background: #96ca51;
    }
}

</style>
